const initCartSummary = async () => {
  const productsTotal = document.querySelector('[data-order-products-total]');
  const deliveryTotal = document.querySelector('[data-order-delivery-total]');
  const orderTotal = document.querySelector('[data-order-total]');
  const deliveryMessage = document.querySelector('[data-delivery-message]');

  if (!productsTotal || !orderTotal) {
    return;
  }

  const body = new URLSearchParams({
    action: 'get_cart_summary',
    nonce: wooSettings.cartSummaryNonce,
  });

  try {
    const response = await fetch(wooSettings.ajaxUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      credentials: 'same-origin',
      body,
    });

    const result = await response.json();

    if (!result.success) {
      return;
    }

    productsTotal.innerHTML = result.data.productsTotal;

    if (deliveryTotal) {
      deliveryTotal.innerHTML = result.data.deliveryTotal;
    }

    orderTotal.innerHTML = result.data.orderTotal;
    if (deliveryMessage) {
      deliveryMessage.textContent = result.data.deliveryMessage;
    }
  } catch (error) {
    console.error('Не удалось обновить сумму заказа', error);
  }
};

export {initCartSummary};